var componentDefs =
[
    { id: "account-settings-basic", container: "account-settings-basic", renderAsKOComponent: true, viewModel: "AccountSettings", path: "account", js: "account-settings.js", html: "account-settings.html" },
    { id: "account-settings-subscription", container: "account-settings-subscription", renderAsKOComponent: true, viewModel: "ActiveSubscription", path: "account", js: "subscription.js", html: "subscription.html" },
    { id: "account-settings-invoices", container: "account-settings-invoices", renderAsKOComponent: true, viewModel: "Invoices", path: "account", js: "invoices.js", html: "invoices.html" },
    { id: "account-settings-security", container: "account-settings-security", renderAsKOComponent: true, viewModel: "TwoFactorAuthentication", path: "account", js: "security.js", html: "security.html" },

    { id: "my-computers-computers", container: "my-computers-computers", viewModel: "MyComputers" },
    { id: "my-computers-events", container: "my-computers-events", viewModel: "AccountEvents", path: "mycomputers", js: "account-events.js", html: "account-events.html" },
    { id: "my-computers-reports", container: "my-computers-reports", viewModel: "Reports", path: "mycomputers", js: "reports.js", html: "reports.html" },
    { id: "my-computers-add", container: "my-computers-add", viewModel: "AddComputer", path: "mycomputers", js: "add-computer.js", html: "add-computer.html" },

    { id: "computer-summary", container: "computer-summary", viewModel: "ComputerSummary", path: "computer/summary", js: "summary.js", html: "summary.html" },
    { id: "computer-hardware", container: "computer-hardware" },
    { id: "computer-software", container: "computer-software" },
    { id: "computer-ccleaner", container: "computer-ccleaner" },
    { id: "computer-tools", container: "computer-tools" },
    { id: "computer-events", container: "computer-events", viewModel: "ComputerEvents", path: "computer/events", js: "computer-events.js", html: "computer-events.html" },
    { id: "computer-options", container: "computer-options" },

    { id: "summary-graph-bandwidth", container: "summary-graph-bandwidth", viewModel: "SummaryBandwidth", path: "computer/summary", js: "summary-bandwidth.js", html: "summary-chart.html" },
    { id: "summary-graph-cpu", container: "summary-graph-cpu", viewModel: "SummaryCPU", path: "computer/summary", js: "summary-cpu.js", html: "summary-chart.html" },
    { id: "summary-graph-ram", container: "summary-graph-ram", viewModel: "SummaryRAM", path: "computer/summary", js: "summary-ram.js", html: "summary-chart.html" },
    { id: "summary-processes", container: "summary-processes", viewModel: "SummaryProcesses", path: "computer/summary", js: "summary-processes.js", html: "summary-processes.html"},
    { id: "summary-drive-space", container: "summary-drive-space" },
    { id: "summary-drive-activity", container: "summary-drive-activity", viewModel: "SummaryDriveActivity", path: "computer/summary", js: "summary-driveactivity.js", html: "summary-driveactivity.html" },

    { id: "computer-hardware-overview", container: "computer-hardware-overview", viewModel: "HardwareOverview", path: "computer/hardware", js: "hardware-overview.js", html: "speccy-section.html" },
    { id: "computer-hardware-cpu", container: "computer-hardware-cpu", viewModel: "HardwareCPU", path: "computer/hardware", js: "hardware-cpu.js", html: "speccy-section.html" },
    { id: "computer-hardware-ram", container: "computer-hardware-ram", viewModel: "HardwareRAM", path: "computer/hardware", js: "hardware-ram.js", html: "speccy-section.html" },
    { id: "computer-hardware-motherboard", container: "computer-hardware-motherboard", viewModel: "HardwareMotherboard", path: "computer/hardware", js: "hardware-motherboard.js", html: "speccy-section.html" },
    { id: "computer-hardware-graphics", container: "computer-hardware-graphics", viewModel: "HardwareGraphics", path: "computer/hardware", js: "hardware-graphics.js", html: "speccy-section.html" },
    { id: "computer-hardware-hd", container: "computer-hardware-hd", viewModel: "HardDrives", path: "computer/hardware", js: "hardware-hd.js", html: "speccy-section.html" },
    { id: "computer-hardware-od", container: "computer-hardware-od", viewModel: "HardwareOpticalDrives", path: "computer/hardware", js: "hardware-od.js", html: "speccy-section.html" },
    { id: "computer-hardware-audio", container: "computer-hardware-audio", viewModel: "HardwareAudio", path: "computer/hardware", js: "hardware-audio.js", html: "speccy-section.html" },
    { id: "computer-hardware-peripherals", container: "computer-hardware-peripherals", viewModel: "HardwarePeripherals", path: "computer/hardware", js: "hardware-peripherals.js", html: "speccy-section.html" },
    { id: "computer-hardware-network", container: "computer-hardware-network", viewModel: "HardwareNetwork", path: "computer/hardware", js: "hardware-network.js", html: "speccy-section.html" },

    { id: "computer-software-os", container: "computer-software-os", viewModel: "SoftwareOS", js: "computer/software/software-os.js", html: "computer/hardware/speccy-section.html" },
    { id: "computer-software-processes", container: "computer-software-processes", viewModel: "SoftwareProcesses", path: "computer/software", js: "software-processes.js", html: "software-processes.html" },
    { id: "computer-software-startups", container: "computer-software-startups", viewModel: "SoftwareStartups", path: "computer/software", js: "software-startups.js", html: "software-startups.html" },
    { id: "computer-software-installs", container: "computer-software-installs", viewModel: "SoftwareInstalls", path: "computer/software", js: "software-installs.js", html: "software-installs.html" },
    { id: "computer-software-add", container: "computer-software-add", viewModel: "AddSoftware", path: "computer/software", js: "software-add.js", html: "software-add.html" },
    { id: "computer-software-wus", container: "computer-software-wus", viewModel: "SoftwareWUS", path: "computer/software", js: "software-wus.js", html: "software-wus.html" },

    { id: "computer-ccleaner-ccleaner", container: "computer-ccleaner-ccleaner", viewModel: "CCleaner", path: "computer/ccleaner", js: "ccleaner.js", html: "ccleaner.html" },
    { id: "computer-ccleaner-registry", container: "computer-ccleaner-registry", viewModel: "CCleanerRegistry", path: "computer/ccleaner", js: "ccleaner-registry.js", html: "ccleaner-registry.html" },
    { id: "ccleaner-tools-restore", container: "ccleaner-tools-restore", viewModel: "SystemRestore", path: "computer/ccleaner", js: "ccleaner-tools-restore.js", html: "ccleaner-tools-restore.html" },
    { id: "ccleaner-tools-wiper", container: "ccleaner-tools-wiper", viewModel: "DriveWiper", path: "computer/ccleaner", js: "ccleaner-tools-wiper.js", html: "ccleaner-tools-wiper.html" },
    { id: "ccleaner-options-settings", container: "ccleaner-options-settings", viewModel: "CCleanerSettings", path: "computer/ccleaner", js: "ccleaner-options-settings.js", html: "ccleaner-options-settings.html" },
    { id: "ccleaner-options-cookies", container: "ccleaner-options-cookies", viewModel: "CCleanerCookies", path: "computer/ccleaner", js: "ccleaner-options-cookies.js", html: "ccleaner-options-cookies.html" },
    { id: "ccleaner-options-includes", container: "ccleaner-options-includes", viewModel: "CCleanerIncludes", path: "computer/ccleaner", js: "ccleaner-options-includes.js", html: "ccleaner-options-includes.html" },
    { id: "ccleaner-options-excludes", container: "ccleaner-options-excludes", viewModel: "CCleanerExcludes", path: "computer/ccleaner", js: "ccleaner-options-excludes.js", html: "ccleaner-options-excludes.html" },
    { id: "ccleaner-options-users", container: "ccleaner-options-users", viewModel: "CCleanerUsers", path: "computer/ccleaner", js: "ccleaner-options-users.js", html: "ccleaner-options-users.html" },

    { id: "computer-tools-defraggler", container: "computer-tools-defraggler", viewModel: "Defraggler", path: "computer/tools", js: "tools-defraggler.js", html: "tools-defraggler.html" },
    { id: "computer-tools-network", container: "computer-tools-network", viewModel: "Network", path: "computer/tools", js: "tools-network.js", html: "tools-network.html" },
    { id: "computer-tools-shutdown", container: "computer-tools-shutdown", viewModel: "Shutdown", path: "computer/tools", js: "tools-shutdown.js", html: "tools-shutdown.html" },

    { id: "computer-options-agent", container: "computer-options-agent", viewModel: "AgentOptions", path: "computer/options", js: "options-agent.js", html: "options-agent.html" },
    { id: "computer-options-events", container: "computer-options-events", viewModel: "EventsOptions", path: "computer/options", js: "options-events.js", html: "options-events.html" },
    { id: "computer-options-scheduling", container: "computer-options-scheduling" },
    { id: "computer-options-scheduling-cc", container: "computer-options-scheduling-cc", viewModel: "CCSchedule", path: "computer/options", js: "options-scheduling-cc.js", html: "options-scheduling-cc.html" },
    { id: "computer-options-scheduling-df", container: "computer-options-scheduling-df", viewModel: "DFSchedules", path: "computer/options", js: "options-scheduling-df.js", html: "options-scheduling-df.html" }
];

var popupDefs =
[
    {
        id: "review-unconfirmedendpoints-popup",
        container: "main-content",
        viewModel: "ReviewUnconfirmedEndpoints",
        path: "popups",
        require: ["vm-reviewunconfirmedendpoints"],
        html: "reviewunconfirmedendpoints.html"
    },
    {
        id: "contact-us-popup",
        container: "main-content",
        viewModel: "ContactUs",
        path: "popups",
        require: ["vm-contactus"],
        html: "contact-us.html"
    },
    {
        id: "add-computer-popup",
        container: "my-computers-computers",
        viewModel: "AddComputer",
        path: "mycomputers/popups",
        require: ["vm-addcomputer"],
        html: "add-computer.html"
    },
    {
        id: "add-group-popup",
        container: "my-computers-computers",
        viewModel: "AddComputerGroup",
        path: "mycomputers/popups",
        require: ["vm-addcomputergroup"],
        html: "add-computer-group.html"
    },
    {
        id: "copy-settings-popup",
        container: "my-computers-computers",
        viewModel: "CopySettings",
        path: "mycomputers/popups",
        require: ["vm-copysettings"],
        html: "copy-settings.html"
    },
    {
        id: "add-software-popup",
        container: "my-computers-computers",
        viewModel: "AddSoftware",
        path: "mycomputers/popups",
        require: ["vm-addsoftware"],
        html: "add-software.html"
    },
    {
        id: "add-computers-popup",
        container: "account-settings-main",
        viewModel: "AddComputers",
        path: "account/popups",
        require: ["vm-addcomputers"],
        html: "add-computers.html"
    },
    {
        id: "move-computers-popup",
        container: "my-computers-computers",
        viewModel: "MoveComputers",
        path: "mycomputers/popups",
        require: ["vm-movecomputers"],
        html: "move-computers.html"
    },
    {
        id: "delete-computers-popup",
        container: "my-computers-computers",
        viewModel: "DeleteComputers",
        path: "mycomputers/popups",
        require: ["vm-deletecomputers"],
        html: "delete-computers.html"
    },
    {
        id: "ccleaner-popup",
        container: "my-computers-computers",
        viewModel: "CCleaner",
        path: "mycomputers/popups",
        require: ["vm-ccleaner"],
        html: "ccleaner.html"
    },
    {
        id: "defraggler-popup",
        container: "my-computers-computers",
        viewModel: "Defraggler",
        path: "mycomputers/popups",
        require: ["vm-defraggler"],
        html: "defraggler.html"
    },
    {
        id: "confirm-password-dialog",
        container: "account-settings-subscription",
        viewModel: "ConfirmPasswordDialog",
        path: "popups",
        require: ["vm-confirmpassworddialog"],
        html: "confirm-password-dialog.html"
    },
    {
        id: "create-subscription-popup",
        container: "account-settings-main",
        viewModel: "UpgradeSubscription",
        path: "account/popups",
        require: ["vm-upgradesubscription"],
        html: "create-subscription.html"
    },
    {
        id: "update-subscription-popup",
        container: "account-settings-main",
        viewModel: "UpgradeSubscription",
        path: "account/popups",
        require: ["vm-upgradesubscription"],
        html: "update-subscription.html"
    },
    {
        id: "recovery-code-popup",
        container: "account-settings-main",
        viewModel: "DisplayRecovery",
        path: "account/popups",
        require: ["vm-recoverycode"],
        html: "recovery-code.html"
    },
    {
        id: "choose-computers-popup",
        container: "trial-expiry-main",
        viewModel: "TrailExpiry",
        path: "popups",
        html: "choose-computers.html"
    },
    {
        id: "change-computer-name-popup",
        container: "computer-options-agent",
        viewModel: "ChangeComputerName",
        path: "computer/popups",
        require: ["vm-changecomputername"],
        html: "change-computer-name.html"
    },
    {
        id: "select-startup-item-user-popup",
        container: "computer-software",
        viewModel: "SelectStartupItemUser",
        path: "computer/popups",
        require: ["vm-selectstartupitemuser"],
        html: "select-startup-item-user.html"
    },
    {
        id: "delete-computer-popup",
        container: "computer-options-agent",
        viewModel: "DeleteComputer",
        path: "computer/popups",
        require: ["vm-deletecomputer"],
        html: "delete-computer.html"
    },
    {
        id: "cc-include-exclude-popup",
        container: "ccleaner-options-includes",
        viewModel: "AddEditCCleanerIncludeExclude",
        path: "computer/popups",
        require: ["vm-addeditccleanerincludeexclude"],
        html: "add-edit-ccleaner-include-exclude.html"
    },
    {
        id: "cc-cookie-popup",
        container: "ccleaner-options-cookies",
        viewModel: "AddCookie",
        path: "computer/popups",
        require: ["vm-addcookie"],
        html: "add-cookie.html"
    },
    {
        id: "rename-installed-software-popup",
        container: "computer-software-installs",
        viewModel: "RenameInstalledSoftware",
        path: "computer/popups",
        require: ["vm-renameinstalledsoftware"],
        html: "rename-installed-software.html"
    },
    {
        id: "install-wus-popup",
        container: "computer-software-wus",
        viewModel: "InstallWus",
        path: "computer/popups",
        require: ["vm-installwus"],
        html: "install-wus.html"
    },
    {
        id: "install-software-popup",
        container: "computer-software-add",
        viewModel: "InstallSoftware",
        path: "computer/popups",
        require: ["vm-installsoftware"],
        html: "install-software.html"
    },
    {
        id: "login-popup",
        container: "login-popup-container",
        viewModel: "Login",
        path: "",
        require: ["vm-login"],
        html: "public/login"
    }
];

/* COMPONENT LOADING FUNCTIONS */

function loadComponent(ko, componentName, containerId, viewModel, path, htmlFile, jsFile, renderAsKOComponent, requireObject, renderCompleteCallback) {

    var rootPath = cccApp.settings.cdn + "scripts/components/";

    var hasJs = (typeof jsFile !== "undefined" && jsFile !== null && jsFile !== "");
    var hasHtml = (typeof htmlFile !== "undefined" && htmlFile !== null && htmlFile !== "");
    var asComponent = (typeof renderAsKOComponent === "boolean" && renderAsKOComponent);

    //TODO: Test if an initial fail to load causes the global definitions to have the file path appended,
    //      instead of just affecting the local variable. 
    //      A second attempt to load the component cuases the paths to be appended again.
    if (typeof path !== "undefined" && path !== null) {
        jsFile = rootPath + path + "/" + jsFile;
        htmlFile = rootPath + path + "/" + htmlFile;
    } else {
        jsFile = rootPath + jsFile;
        htmlFile = rootPath + htmlFile;
    }

    if (typeof renderCompleteCallback !== "function") {
        renderCompleteCallback = null;
    }
    if (hasJs && hasHtml) {
        var content = $("#" + containerId).html();
        if (content === "") {
            $("#" + containerId).html('<div class="col-xs-12 pad-left pre-render"><h1>Loading...</h1></div>');
        }

        require([jsFile, "text!" + htmlFile], function (model, html) {
                if (typeof model === "undefined" || model === null) {
                    cccApp.models[viewModel] = new window[viewModel]();
                    model = cccApp.models[viewModel];
                }

                if (asComponent) {
                    ko.components.register(componentName,
                    {
                        viewModel: { instance: model },
                        template: html
                    });
                }

                renderComponent({
                    initialize: true,
                    viewmodel: model,
                    errorMessage: "Sorry, there was a problem while loading this tab",
                    bindings: function () {
                        var component;

                        if (asComponent) {
                            component = $("<" + componentName + ">");
                            $("#" + containerId).html(component);
                            ko.applyBindings({}, component[0]);
                        } else {
                            component = $(html);
                            $("#" + containerId).html(component);
                            ko.applyBindings(model, component[0].parentElement);  
                        }
                    },
                    complete: renderCompleteCallback
                });
        }, function (err) {
            logRequireError("Require", false, "Sorry, there was a problem while loading this tab", "global-messages", err, {
                context: {
                    componentName: componentName,
                    containerId: containerId,
                    viewModel: viewModel,
                    path: path,
                    htmlFile: htmlFile,
                    jsFile: jsFile
                }
            });
        });
    } else if (hasJs) {
        require([jsFile], function (js) {
            //Do Nothing
        }, function (err) {
            logRequireError("Require", false, "Sorry, there was a problem while running a script", "global-messages", err, {
                context: {
                    componentName: componentName,
                    containerId: containerId,
                    viewModel: viewModel,
                    path: path,
                    htmlFile: htmlFile,
                    jsFile: jsFile
                }
            });
        });
    } else if (hasHtml) {
        require(["text!" + htmlFile], function (html) {
            if (html) {
                var component = $(html);
                $("#" + containerId).html(component);
            }
        }, function (err) {
            logRequireError("Require", false, "Sorry, there was a problem while loading this tab", "global-messages", err, {
                context: {
                    componentName: componentName,
                    containerId: containerId,
                    viewModel: viewModel,
                    path: path,
                    htmlFile: htmlFile,
                    jsFile: jsFile
                }
            });
        });
    }

    return null;
}

function loadPopup(ko, popupId, popupConfig, activity, isUrl) {

    popupConfig = popupConfig || {};
    activity = activity || "";
    isUrl = typeof isUrl === "boolean" ? isUrl : false;

    var rootPath = "scripts/components/";

    var def = popupDefs.filter(function (obj) {
        return obj.id === popupId;
    });

    if (def && def[0]) {

        def = def[0];

        var popupContainer = $("#" + def.id);

        if ((typeof def.require === "undefined") || (!cccApp.models[def.viewModel] &&
            (typeof popupContainer === "undefined" || popupContainer === null || popupContainer.length === 0))) {

            var htmlFile;

            if (!isUrl) {
                if (def.path) {
                    htmlFile = rootPath + def.path + "/" + def.html;
                } else {
                    htmlFile = rootPath + def.html;
                }
            } else {
                htmlFile = "/" + def.html;
            }

            var requireArray = [];

            if (typeof def.require === "string") {
                requireArray.push(def.require);
            } else if (Object.prototype.toString.call(def.require) === "[object Array]") {
                requireArray = def.require;
            }
            
            if (def.html) {
                requireArray.push("text!" + htmlFile);
            }

            if (typeof def.require !== "undefined") {
                requireVmHtml(requireArray, def, popupConfig, activity);
            } else {
                requireHtml(requireArray, def, popupConfig, activity);
            }
        } else if (!cccApp.models[def.viewModel] && typeof popupContainer !== "undefined" && popupContainer !== null && popupContainer.length > 0) {
            cccApp.msg.error("Sorry, there was a problem opening this popup.  Please refresh the page and try again");
        } else {
            renderComponent({
                initialize: false,
                viewmodel: cccApp.models[def.viewModel],
                popupConfig: popupConfig,
                activity: activity,
                errorMessage: "Sorry, there was a problem while loading this pop-up",
                complete: function () {
                    cccApp.openPopup(def.id, popupConfig, true);
                }
            });
        }
    }
}

function requireVmHtml(requireArray, def, popupConfig, activity) {
    require(requireArray,function (vm, html) {
        if (vm && html) {

            if (typeof cccApp.models[def.viewModel] === "undefined" ||
                cccApp.models[def.viewModel] === null) {
                cccApp.models[def.viewModel] = new vm();
            }

            popupConfig = popupConfig || {};

            renderComponent({
                initialize: true,
                viewmodel: cccApp.models[def.viewModel],
                popupConfig: popupConfig,
                activity: activity,
                errorMessage: popupConfig.errorMessage || "Sorry, there was a problem while loading this pop-up",
                messagePlaceholder: popupConfig.messagePlaceholder || "global-messages",
                bindings: function() {
                    var component = $(html);
                    $("#" + def.container).append(component);
                    ko.applyBindings(cccApp.models[def.viewModel], component[0]);
                },
                complete: function () {
                    cccApp.openPopup(def.id, popupConfig, true);
                }
            });
        }
    },
    function (err) {
        logRequireError(activity + " Require", false, "Sorry, there was a problem while loading this pop-up", "global-messages", err, {
            context: {
                popupId: def.id,
                popupDefinition: def,
                popupConfig: popupConfig
            }
        });
    });
}

function requireHtml(requireArray, def, popupConfig, activity) {
    require(requireArray, function (html) {
        if ( html) {
            popupConfig = popupConfig || {};

            renderComponent({
                initialize: true,
                viewmodel: cccApp.models[def.viewModel],
                popupConfig: popupConfig,
                activity: activity,
                errorMessage: popupConfig.errorMessage || "Sorry, there was a problem while loading this pop-up",
                messagePlaceholder: popupConfig.messagePlaceholder || "global-messages",
                bindings: function () {
                    var component = $(html);
                    $("#" + def.container).append(component);
                    ko.applyBindings(cccApp.models[def.viewModel], component[0]);
                },
                complete: function () {
                    cccApp.openPopup(def.id, popupConfig, true);
                }
            });
        }
    },
    function (err) {
        logRequireError(activity + " Require", false, "Sorry, there was a problem while loading this pop-up", "global-messages", err, {
            context: {
                popupId: def.id,
                popupDefinition: def,
                popupConfig: popupConfig
            }
        });
    });
}

function loadDialog(title, subTitle, question, yesHandler, noHandler, popupConfig, cssClass, isNoPrimaryAction) {
    var id = "dialog-popup";

    popupConfig = popupConfig || {};

    var config = $.extend(true, {}, popupConfig);

    var closePopup = function () { cccApp.closePopup(); };

    yesHandler = combineHandlerFunctions(yesHandler, closePopup);
    noHandler = combineHandlerFunctions(noHandler, closePopup);

    var vm = {
        title: title,
        subTitle: subTitle || "",
        question: question,
        "Yes": yesHandler,
        "No": noHandler,
        cssClass: cssClass || "",
        isNoPrimaryAction: isNoPrimaryAction || false
};

    var afterClose = function () {
        var popupContentNode = $("#" + id);
        if (popupContentNode.length > 0) {
            ko.cleanNode(popupContentNode[0]);
        }
    };
    var afterOpen = function () {
        var popupContentNode = $(".featherlight-content #" + id);
        if (popupContentNode.length > 0) {
            ko.applyBindings(vm, popupContentNode[0]);
        }
    };

    if (popupConfig.afterClose) {
        afterClose = combineHandlerFunctions(popupConfig.afterClose, afterClose);
    }

    if (popupConfig.afterOpen) {
        afterOpen = combineHandlerFunctions(popupConfig.afterOpen, afterOpen);
    }

    config.afterClose = afterClose;
    config.afterOpen = afterOpen;

    cccApp.openPopup(id, config);

}

function loadSecureDialog(title, subTitle, additionalText, yesText, noText, yesHandler, noHandler, popupConfig) {
    popupConfig = $.extend({}, popupConfig, {
        beforeOpen: function () {
            var model = cccApp.models.ConfirmPasswordDialog;
            model.title(title);
            model.subTitle(subTitle);
            model.additionalText(additionalText);
            model.submitText(yesText);
            model.cancelText(noText);
            model.submitHandler = yesHandler;
            model.closeHandler = noHandler;
        }
    });

    loadPopup(ko, "confirm-password-dialog", popupConfig);

}

function combineHandlerFunctions(functionOne, functionTwo) {

    var combined = function() {};

    if (functionOne) {
        combined = function () {
            functionOne();
            if (functionTwo) {
                functionTwo.apply(this, arguments);
            }
        };
    } else {
        if (functionTwo) {
            combined = functionTwo;
        }
    }

    return combined;
}

function renderComponent(params) {
    params = params || {};

    var initialize = params.initialize;
    var viewmodel = params.viewmodel;
    var popupConfig = params.popupConfig;
    var bindings = params.bindings;
    var complete = params.complete;

    var activity = params.activity || "";
    var errorMessage = params.errorMessage || "Sorry, there was a problem while loading this component";
    var messagePlaceholder = params.messagePlaceholder || "global-messages";

    try {
        if (!viewmodel) {
            cccApp.msg.error(errorMessage, messagePlaceholder);
            logError(activity, false, { "error": "RenderComponent called without viewmodel" });
            return;
        }

        // 1) Pre-Bind
        if (initialize && typeof viewmodel.prebind === "function") {
            viewmodel.prebind(prebindComplete);
        } else {
            prebindComplete();
        }

        function prebindComplete() {
            // 2) Apply Bindings
            if (bindings && typeof bindings === "function") {
                bindings();
            }

            // 3) Init
            if (initialize) {
                if (typeof viewmodel.init === "function") {
                    viewmodel.init();
                }

                if (popupConfig && typeof popupConfig.init === "function") {
                    popupConfig.init(viewmodel);
                }
            }

            // 4) Render
            if (typeof viewmodel.render === "function") {
                viewmodel.render();
            }

            if (popupConfig && typeof popupConfig.render === "function") {
                popupConfig.render(viewmodel);
            }

            // 5) Close callback
            if (popupConfig && typeof popupConfig.afterClose === "function") {
                var callback = popupConfig.afterClose;
                popupConfig.afterClose = function() {
                    if (viewmodel) {
                        callback(viewmodel);
                    }
                };
            }

            // 6) Complete
            if (complete && typeof complete === "function") {
                complete(viewmodel);
            }
        }

    } catch (e) {
        cccApp.msg.error(errorMessage, messagePlaceholder);
        logError(activity, false, { "error": e.message });

        if (cccApp && cccApp.settings && cccApp.settings.isDebugMode) {
            if (console && console.error) {
                console.error(e);
            }
        }
    }
}